"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var style_1 = require("@lyearn/style");
function SvgArrowForward(_props, svgRef) {
    var props = (0, style_1.useSvg)(_props);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 24 24", ref: svgRef }, props),
        React.createElement("g", { "data-name": "Layer 2" },
            React.createElement("path", { d: "M5 13h11.86l-3.63 4.36a1 1 0 001.54 1.28l5-6a1.19 1.19 0 00.09-.15c0-.05.05-.08.07-.13A1 1 0 0020 12a1 1 0 00-.07-.36c0-.05-.05-.08-.07-.13a1.19 1.19 0 00-.09-.15l-5-6A1 1 0 0014 5a1 1 0 00-.64.23 1 1 0 00-.13 1.41L16.86 11H5a1 1 0 000 2z", "data-name": "arrow-forward" }))));
}
exports["default"] = React.forwardRef(SvgArrowForward);
//# sourceMappingURL=ArrowForward.js.map